// Class: openfl.display._internal.CanvasShape

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
function openfl_display__$internal_CanvasGraphics() {return require("./../../../openfl/display/_internal/CanvasGraphics");}
function openfl_geom_Matrix() {return require("./../../../openfl/geom/Matrix");}

// Constructor

var CanvasShape = function(){}

// Meta

CanvasShape.__name__ = "openfl.display._internal.CanvasShape";
CanvasShape.__isInterface__ = false;
CanvasShape.prototype = {
	
};
CanvasShape.prototype.__class__ = CanvasShape.prototype.constructor = $hxClasses["openfl.display._internal.CanvasShape"] = CanvasShape;

// Init



// Statics

CanvasShape.render = function(shape,renderer) {
	if(!shape.__renderable) {
		return;
	}
	var alpha = renderer.__getAlpha(shape.__worldAlpha);
	if(alpha <= 0) {
		return;
	}
	var graphics = shape.__graphics;
	if(graphics != null) {
		(openfl_display__$internal_CanvasGraphics().default).render(graphics,renderer);
		var width = graphics.__width;
		var height = graphics.__height;
		var canvas = graphics.__canvas;
		if(canvas != null && graphics.__visible && width >= 1 && height >= 1) {
			var transform = graphics.__worldTransform;
			var context = renderer.context;
			var scrollRect = shape.__scrollRect;
			if(scrollRect == null || scrollRect.width > 0 && scrollRect.height > 0) {
				renderer.__setBlendMode(shape.__worldBlendMode);
				renderer.__pushMaskObject(shape);
				context.globalAlpha = alpha;
				var renderTransform = (openfl_geom_Matrix().default).__pool.get();
				renderTransform.scale(1 / graphics.__bitmapScaleX,1 / graphics.__bitmapScaleY);
				renderTransform.concat(transform);
				renderer.setTransform(renderTransform,context);
				context.drawImage(canvas,0,0,width,height);
				(openfl_geom_Matrix().default).__pool.release(renderTransform);
				renderer.__popMaskObject(shape);
			}
		}
	}
}
CanvasShape.__meta__ = { obj : { SuppressWarnings : ["checkstyle:FieldDocComment"]}}

// Export

exports.default = CanvasShape;